import { render } from "./EloList.vue?vue&type=template&id=0809db3a"
import script from "./EloList.vue?vue&type=script&lang=js"
export * from "./EloList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__